import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { Row, Col } from 'react-flexbox-grid';
import { Button, Form, Modal, Spin } from 'antd';
import { socialStatus } from '../../../../common/enums';
import InsuranceForm from './insuranceForm';

const showEmployerStatuses = [
  socialStatus.EMPLOYED_INDEFINITE,
  socialStatus.EMPLOYED_DEFINITE,
  socialStatus.AGREEMENT_OTHER,
];

@Form.create()
@translate()
export default class StepInsurance extends Component {
  static propTypes = {
    accountData: PropTypes.object.isRequired,
    form: PropTypes.object.isRequired,
    isLoading: PropTypes.bool.isRequired,
    submit: PropTypes.func.isRequired,
    goBack: PropTypes.func.isRequired,
    calculator: PropTypes.object.isRequired,
    insuranceInfo: PropTypes.object,
    onInsuranceChange: PropTypes.func,
    t: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      insuranceValue: props.calculator ? props.calculator.insurance : null,
      showInvalidModal: false,
    };
  }

  checkInsuranceEligibility() {
    const { form } = this.props;
    const { insuranceValue } = this.state;

    if (insuranceValue && insuranceValue !== 'C') {
      if (
        !form.getFieldValue('youngerThanLimit') ||
        form.getFieldValue('pension') ||
        form.getFieldValue('invalidity') ||
        form.getFieldValue('unableToWork')
      ) {
        this.setState({ showInvalidModal: true });
        return false;
      }
    }
    return true;
  }

  handleInsuranceValueChange = (value) => {
    const { form } = this.props;
    const { insuranceValue } = this.state;

    const newVal = insuranceValue === value ? null : value;
    const insuranceFields = ['A', 'B', 'C'];
    insuranceFields.forEach(key => {
      form.setFieldsValue({ [`insurance${key}`]: newVal === key });
    });

    this.setState({ insuranceValue: newVal });

    // Recompute the monthly insurance price + payment in the container so the
    // displayed amount and the value persisted on submit are correct (not 0).
    if (this.props.onInsuranceChange) {
      this.props.onInsuranceChange(newVal);
    }
  };

  submitForm = (formData) => {
    const { submit } = this.props;
    const { insuranceValue } = this.state;

    delete formData.insuranceA;
    delete formData.insuranceB;
    delete formData.insuranceC;

    formData.insurance = insuranceValue;

    submit(formData);
  };

  handleSubmit = () => {
    const { form } = this.props;

    form.validateFields((err, formData) => {
      if (err) {
        return;
      }

      if (!this.checkInsuranceEligibility()) {
        return;
      }

      this.submitForm(formData);
    });
  };

  continueWithoutInsurance = () => {
    const { form } = this.props;
    const insuranceFields = ['A', 'B', 'C'];
    insuranceFields.forEach(key => {
      form.setFieldsValue({ [`insurance${key}`]: false });
    });

    this.setState({ insuranceValue: null, showInvalidModal: false }, () => {
      form.validateFields((err, formData) => {
        if (err) {
          return;
        }
        this.submitForm(formData);
      });
    });
  };

  render() {
    const { form, isLoading, calculator, insuranceInfo, accountData, t } = this.props;
    const { insuranceValue, showInvalidModal } = this.state;

    if (!calculator) {
      return <Spin spinning={true} />;
    }

    const showEmployer = !!(accountData && showEmployerStatuses.includes(accountData.socialStatus));

    return (
      <section className="onboarding-form">
        <Spin spinning={isLoading}>
          <Form layout="vertical">
            <InsuranceForm
              form={form}
              t={t}
              payment={calculator.payment}
              insuranceAmount={calculator.insuranceAmount}
              insuranceInfo={insuranceInfo}
              onBlurSaveLoanData={() => {}}
              showEmployer={showEmployer}
              handleInsuranceValueChange={this.handleInsuranceValueChange}
              insuranceValue={insuranceValue}
            />

            <Row center="xs" className="form-actions-row">
              <Col xs={12} sm={6} className="form-actions-col">
                <a onClick={this.props.goBack}>{t('Späť')}</a>
                <Button
                  type="primary"
                  size="large"
                  className="btn-block"
                  onClick={this.handleSubmit}
                  loading={isLoading}
                >
                  {t('Dokončiť žiadosť')}
                </Button>
              </Col>
            </Row>
          </Form>
        </Spin>

        <Modal
          title={t('Nie je možné vytvoriť poistenie')}
          visible={showInvalidModal}
          onCancel={() => this.setState({ showInvalidModal: false })}
          width={600}
          footer={
            <Row>
              <Col sm={6}>
                <Button
                  size="small"
                  type="primary"
                  onClick={this.continueWithoutInsurance}
                >
                  {t('Pokračovať bez poistenia')}
                </Button>
              </Col>
              <Col>
                <Button
                  size="small"
                  type="primary"
                  onClick={() => {
                    this.handleInsuranceValueChange('C');
                    this.setState({ showInvalidModal: false });
                  }}
                >
                  {t('Pokračovať s poistením C')}
                </Button>
              </Col>
            </Row>
          }
        >
          <div>
            {t('Žiaľ, na základe vami zvolených údajov vám nevieme ponúknuť vybraný poistný balík ')}
            {insuranceValue}
            {t(', avšak vieme vám ponúknť poistný balík C.')}
          </div>
        </Modal>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/onboarding/components/debtor/StepInsurance.js